var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6398 25.7787C32.6653 27.5561 31.3781 29.7779 29.33 29.7779H2.66968C0.617627 29.7779 -0.663595 27.5527 0.359849 25.7787L13.6902 2.666C14.7161 0.887719 17.2857 0.890941 18.3098 2.666L31.6398 25.7787Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6398 25.7787C32.6653 27.5561 31.3781 29.7779 29.33 29.7779H2.66968C0.617627 29.7779 -0.663595 27.5527 0.359849 25.7787L13.6902 2.666C14.7161 0.887719 17.2857 0.890941 18.3098 2.666L31.6398 25.7787ZM16 21.0002C14.5886 21.0002 13.4445 22.1443 13.4445 23.5557C13.4445 24.9671 14.5886 26.1113 16 26.1113C17.4114 26.1113 18.5556 24.9671 18.5556 23.5557C18.5556 22.1443 17.4114 21.0002 16 21.0002ZM13.5737 11.8143L13.9858 19.3698C14.0051 19.7234 14.2975 20.0002 14.6515 20.0002H17.3485C17.7026 20.0002 17.9949 19.7234 18.0142 19.3698L18.4263 11.8143C18.4471 11.4324 18.1431 11.1113 17.7606 11.1113H14.2393C13.8569 11.1113 13.5529 11.4324 13.5737 11.8143Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLinkIcon);
export default __webpack_public_path__ + "static/media/no-link-icon.33788bab1d375e1b6e533162ac4227dc.svg";
export { ForwardRef as ReactComponent };